module.exports = "https://www.gc-pro.gnp.com.mx/5750028c9cf1f5606d2b636833190585.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/help_outline_24px.png
// module id = 969
// module chunks = 0